import {
  resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments,
  RemoteAttachment3uyi4s0lht7h0 as RemoteAttachment,
  LocalFileyitm5ua4ch17 as LocalFile,
} from '../../../files/attachmentFilePreview.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
} from '../../../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  LineItem_name_getInstance2tmkd7sdgzzsk as LineItem_name_getInstance,
  LineItem_originalPrice_getInstance21mba1sq9qfcr as LineItem_originalPrice_getInstance,
  LineItem_description_getInstancevytol0at3mie as LineItem_description_getInstance,
  LineItem_files_getInstancel1rkwtgpml47 as LineItem_files_getInstance,
  LineItem_order_getInstancentdi0e9dyong as LineItem_order_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { pushChanges2xw2hvtobowgv as pushChanges } from '../../../../../utils/Draft.ext.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toFileData1whrjalotozwt as toFileData } from '../../../../../extensions/ProjectAttachment.ext.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
  _ServerFile___init__impl__jj3mn23p0pea18kbfe7 as _ServerFile___init__impl__jj3mn2,
  ServerFile1t91jzpzoixwe as ServerFile,
} from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  trim6jpmwojjgb3l as trim,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  LineItem2rt64afaiyloc as LineItem,
  Specification3fgfbf7ihgj8v as Specification,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../../../selectedContractor.mjs';
import { confirmNewSpecDialog2atpg2wu5rk54 as confirmNewSpecDialog } from '../../../../dialogs/ConfirmNewSpecDialog.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../../../nav/crowpay.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
} from '../../../../theming/buttons.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../../dialogs/GenericConfirmationDialog.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Draft43syxm8fng0j as Draft } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { LineItemForm37miaqqv1b4u9 as LineItemForm } from '../../../LineItemForm.mjs';
import {
  Action1a4ymn5nx79hk as Action,
  resize3py5p2yrjp6p7 as resize,
} from '../../../../../utils/utils.mjs';
import { TargetHandler3hwg57jh7lzun as TargetHandler } from '../../../../../utils/JumpTo.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance } from '../../../../theming/sections.mjs';
import { get_withoutPadding21hnjxk91b1qc as get_withoutPadding } from '../../../../theming/appTheme.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration__plus_impl_yu9v8f2gb5hwgakp0dd as Duration__plus_impl_yu9v8f,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_dragHandlemufcu3tsewag as get_dragHandle,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../../../icons.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { DragShadow11keb9piinnfw as DragShadow } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/DragData.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../../../../theming/Titles.mjs';
import {
  weightt34o7llf2uyq as weight,
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77 } from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../../../expansion.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Indent_CenteredSection_getInstance372tfy97032sl as Indent_CenteredSection_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../space.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { Form39thjb3imm7id as Form } from '../../../nav/header.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, it, $completion) {
  var tmp = resolveProjectAttachments($this.ohn_1.ghn_1.f2(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return it.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp);
}
function *_generator_invoke__zhh2q8_0($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var session = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.phn_1.ehn_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = $this.phn_1.ahn_1(tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var fieldsToSave = listOf([LineItem_name_getInstance(), LineItem_originalPrice_getInstance(), LineItem_description_getInstance(), LineItem_files_getInstance(), LineItem_order_getInstance()]);
  if ($this.phn_1.dhn_1.f2()) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.phn_1.khn_1;
    var tmp_3 = await_0(this_2, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    if (tmp_3) {
      var tmp_4 = $this.phn_1.ihn_1.iah(false, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      return Unit_instance;
    }
    var tmp_5 = awaitOnce($this.phn_1.ehn_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var current = tmp_5;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.phn_1.hhn_1;
    var tmp_6 = await_0(this_3, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    if (tmp_6) {
      var tmp_7 = awaitOnce($this.phn_1.ghn_1, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
      var tmp_8 = resolveProjectAttachments(tmp_7, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var newFiles = tmp_8;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(newFiles, 10));
      var _iterator__ex2g4s = newFiles.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp_9 = _ServerFile___init__impl__jj3mn2(substringBefore(_ServerFile___get_location__impl__ddyqaq(item.u79_1), _Char___init__impl__6a9atx(63)));
        var tmp0_safe_receiver = item.v79_1;
        var tmp_10;
        var tmp_11 = tmp0_safe_receiver;
        if ((tmp_11 == null ? null : new (ServerFile())(tmp_11)) == null) {
          tmp_10 = null;
        } else {
          var tmp_12 = tmp0_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_12 == null ? null : new (ServerFile())(tmp_12)).l2n_1;
          tmp_10 = _ServerFile___init__impl__jj3mn2(substringBefore(_ServerFile___get_location__impl__ddyqaq(it), _Char___init__impl__6a9atx(63)));
        }
        var tmp$ret$6 = item.x79(VOID, VOID, tmp_9, tmp_10);
        destination.v(tmp$ret$6);
      }
      var newFilesSimplified = destination;
      // Inline function 'kotlin.collections.map' call
      var this_4 = current.n6k_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().u(collectionSizeOrDefault(this_4, 10));
      var _iterator__ex2g4s_0 = this_4.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var item_0 = _iterator__ex2g4s_0.o1();
        var tmp_13 = _ServerFile___init__impl__jj3mn2(substringBefore(_ServerFile___get_location__impl__ddyqaq(item_0.u79_1), _Char___init__impl__6a9atx(63)));
        var tmp0_safe_receiver_0 = item_0.v79_1;
        var tmp_14;
        var tmp_15 = tmp0_safe_receiver_0;
        if ((tmp_15 == null ? null : new (ServerFile())(tmp_15)) == null) {
          tmp_14 = null;
        } else {
          var tmp_16 = tmp0_safe_receiver_0;
          // Inline function 'kotlin.let' call
          var it_0 = (tmp_16 == null ? null : new (ServerFile())(tmp_16)).l2n_1;
          tmp_14 = _ServerFile___init__impl__jj3mn2(substringBefore(_ServerFile___get_location__impl__ddyqaq(it_0), _Char___init__impl__6a9atx(63)));
        }
        var tmp$ret$11 = item_0.x79(VOID, VOID, tmp_13, tmp_14);
        destination_0.v(tmp$ret$11);
      }
      var oldFiles = destination_0;
      if (!equals(oldFiles, newFilesSimplified)) {
        var tmp_17 = modify($this.phn_1.ehn_1, EditLineItem$save$slambda$slambda_0(newFiles), $completion);
        if (tmp_17 === get_COROUTINE_SUSPENDED())
          tmp_17 = yield tmp_17;
      }
    }
    var tmp_18;
    try {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_5 = get_session();
      var tmp_19 = await_0(this_5, $completion);
      if (tmp_19 === get_COROUTINE_SUSPENDED())
        tmp_19 = yield tmp_19;
      var tmp$ret$14 = tmp_19;
      var tmp_20 = pushChanges($this.phn_1.ehn_1, tmp$ret$14.ofv_1, fieldsToSave, $completion);
      if (tmp_20 === get_COROUTINE_SUSPENDED())
        tmp_20 = yield tmp_20;
      tmp_18 = tmp_20;
    } catch ($p) {
      var tmp_21;
      if ($p instanceof Exception()) {
        var e = $p;
        println('HERE');
        throw e;
      } else {
        throw $p;
      }
    }
    var result = tmp_18;
    var tmp_22 = $this.phn_1.ghn_1.iah(toFileData(result.n6k_1), $completion);
    if (tmp_22 === get_COROUTINE_SUSPENDED())
      tmp_22 = yield tmp_22;
  } else {
    println('Inserting line item');
    var tmp_23 = modify($this.phn_1.ehn_1, EditLineItem$save$slambda$slambda_2($this.phn_1), $completion);
    if (tmp_23 === get_COROUTINE_SUSPENDED())
      tmp_23 = yield tmp_23;
    var tmp_24;
    try {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_6 = get_session();
      var tmp_25 = await_0(this_6, $completion);
      if (tmp_25 === get_COROUTINE_SUSPENDED())
        tmp_25 = yield tmp_25;
      var tmp$ret$15 = tmp_25;
      var tmp_26 = pushChanges($this.phn_1.ehn_1, tmp$ret$15.ofv_1, fieldsToSave, $completion);
      if (tmp_26 === get_COROUTINE_SUSPENDED())
        tmp_26 = yield tmp_26;
      tmp_24 = tmp_26;
    } catch ($p) {
      var tmp_27;
      if ($p instanceof Exception()) {
        var e_0 = $p;
        var tmp_28 = awaitOnce($this.phn_1.ehn_1, $completion);
        if (tmp_28 === get_COROUTINE_SUSPENDED())
          tmp_28 = yield tmp_28;
        var value = tmp_28;
        println('Could not insert ' + value.toString());
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_7 = get_session();
        var tmp_29 = await_0(this_7, $completion);
        if (tmp_29 === get_COROUTINE_SUSPENDED())
          tmp_29 = yield tmp_29;
        var tmp_30 = tmp_29.vfw().gfg_1.mek($completion);
        if (tmp_30 === get_COROUTINE_SUSPENDED())
          tmp_30 = yield tmp_30;
        var perms = tmp_30;
        println('permissions: ' + perms.toString());
        println('passes: ' + perms.x2j_1.r3q(value));
        throw e_0;
      } else {
        throw $p;
      }
    }
    var result_0 = tmp_24;
    var tmp_31 = $this.phn_1.ghn_1.iah(toFileData(result_0.n6k_1), $completion);
    if (tmp_31 === get_COROUTINE_SUSPENDED())
      tmp_31 = yield tmp_31;
    var tmp_32 = $this.phn_1.dhn_1.iah(true, $completion);
    if (tmp_32 === get_COROUTINE_SUSPENDED())
      tmp_32 = yield tmp_32;
  }
  var tmp_33 = $this.phn_1.ihn_1.iah(false, $completion);
  if (tmp_33 === get_COROUTINE_SUSPENDED())
    tmp_33 = yield tmp_33;
  return Unit_instance;
}
var EditLineItem$save$slambda$slambdaClass;
function EditLineItem$save$slambda$slambda() {
  if (EditLineItem$save$slambda$slambdaClass === VOID) {
    class $ {
      constructor($newFiles) {
        this.qhn_1 = $newFiles;
      }
      dgy(it, $completion) {
        return it.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.qhn_1);
      }
      s2(p1, $completion) {
        return this.dgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItem$save$slambda$slambdaClass = $;
  }
  return EditLineItem$save$slambda$slambdaClass;
}
function EditLineItem$save$slambda$slambda_0($newFiles) {
  var i = new (EditLineItem$save$slambda$slambda())($newFiles);
  var l = (it, $completion) => i.dgy(it, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItem$save$slambda$slambdaClass_0;
function EditLineItem$save$slambda$slambda_1() {
  if (EditLineItem$save$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ohn_1 = this$0;
      }
      dgy(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.dgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItem$save$slambda$slambdaClass_0 = $;
  }
  return EditLineItem$save$slambda$slambdaClass_0;
}
function EditLineItem$save$slambda$slambda_2(this$0) {
  var i = new (EditLineItem$save$slambda$slambda_1())(this$0);
  var l = (it, $completion) => i.dgy(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.rhn_1.ehn_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var id = tmp.e6k_1;
    var tmp_0 = await_1($this.rhn_1.dhn_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    if (tmp_0) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_session();
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp_2 = tmp_1.vfw().gfg_1.zfh(id, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    }
    var tmp_3 = $this.rhn_1.zhm_1($this.shn_1, id, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.thn_1.vhn($this.uhn_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_notNullContractor();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.xhn_1.jhn_1.ng8_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.xhn_1.jhn_1.og8_1;
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.xhn_1.jhn_1.qg8_1;
  var tmp_5 = await_0(this_3, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = tmp_5.y5r_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.xhn_1.jhn_1.mg8_1;
  var tmp_7 = await_0(this_4, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = tmp_7;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_5 = $this.xhn_1.jhn_1.gg8_1;
  var tmp_9 = await_0(this_5, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var tmp$ret$5 = tmp_9;
  var tmp_10 = resolveProjectAttachments(tmp$ret$5, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  confirmNewSpecDialog($this.whn_1, new (Specification())(VOID, tmp_0, VOID, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = await_1($this.yhn_1.dhn_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    $this.yhn_1.ehn_1.nai();
    var tmp_0 = awaitOnce($this.yhn_1.ehn_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.yhn_1.ghn_1.iah(toFileData(tmp_0.n6k_1), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = $this.yhn_1.ihn_1.iah(false, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  } else {
    var tmp_3 = $this.yhn_1.vhn($this.zhn_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_notNullContractor();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.bho_1.jhn_1.ng8_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.bho_1.jhn_1.og8_1;
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.bho_1.jhn_1.qg8_1;
  var tmp_5 = await_0(this_3, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = tmp_5.y5r_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.bho_1.jhn_1.mg8_1;
  var tmp_7 = await_0(this_4, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = tmp_7;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_5 = $this.bho_1.jhn_1.gg8_1;
  var tmp_9 = await_0(this_5, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var tmp$ret$5 = tmp_9;
  var tmp_10 = resolveProjectAttachments(tmp$ret$5, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  confirmNewSpecDialog($this.aho_1, new (Specification())(VOID, tmp_0, VOID, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = await_1($this.cho_1.dhn_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    $this.cho_1.ehn_1.nai();
    var tmp_0 = awaitOnce($this.cho_1.ehn_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.cho_1.ghn_1.iah(toFileData(tmp_0.n6k_1), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = $this.cho_1.ihn_1.iah(false, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  } else {
    var tmp_3 = $this.cho_1.vhn($this.dho_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function *_generator_remove__l4h01w($this, _this__u8e3s4, $completion) {
  var tmp;
  var tmp_0 = await_1($this.dhn_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    tmp = to('Delete Work Item?', 'Deleting a work item cannot be undone. Are you sure you want to delete this Work Item?');
  } else {
    tmp = to('Discard Work Item?', 'Discarding unsaved work cannot be undone. Are you sure you want to discard this unsaved Work Item?');
  }
  var _destruct__k2r9zo = tmp;
  var header = _destruct__k2r9zo.cf();
  var removeMessage = _destruct__k2r9zo.df();
  var tmp_1 = get_dialogStack();
  var tmp_2 = trim(header, charArrayOf([_Char___init__impl__6a9atx(63)]));
  var tmp_3 = DangerButtonSemantic_getInstance();
  tmp_1.zgd(new (GenericConfirmationDialog())(header, removeMessage, null, tmp_2, 'Go Back', tmp_3, VOID, VOID, VOID, VOID, EditLineItem$remove$slambda_0($this, _this__u8e3s4)));
  return Unit_instance;
}
var EditLineItem$_init_$slambda_ohwzvpClass;
function EditLineItem$_init_$slambda_ohwzvp() {
  if (EditLineItem$_init_$slambda_ohwzvpClass === VOID) {
    class $ {
      dgy(it, $completion) {
        return Unit_instance;
      }
      s2(p1, $completion) {
        return this.dgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItem$_init_$slambda_ohwzvpClass = $;
  }
  return EditLineItem$_init_$slambda_ohwzvpClass;
}
function EditLineItem$_init_$slambda_ohwzvp_0() {
  var i = new (EditLineItem$_init_$slambda_ohwzvp())();
  var l = (it, $completion) => i.dgy(it, $completion);
  l.$arity = 1;
  return l;
}
function EditLineItem$scopeView$lambda(it) {
  return it.h6k_1;
}
var EditLineItem$save$slambdaClass;
function EditLineItem$save$slambda() {
  if (EditLineItem$save$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.phn_1 = this$0;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItem$save$slambdaClass = $;
  }
  return EditLineItem$save$slambdaClass;
}
function EditLineItem$save$slambda_0(this$0) {
  var i = new (EditLineItem$save$slambda())(this$0);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItem$remove$slambdaClass;
function EditLineItem$remove$slambda() {
  if (EditLineItem$remove$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_remove) {
        this.rhn_1 = this$0;
        this.shn_1 = $this_remove;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItem$remove$slambdaClass = $;
  }
  return EditLineItem$remove$slambdaClass;
}
function EditLineItem$remove$slambda_0(this$0, $this_remove) {
  var i = new (EditLineItem$remove$slambda())(this$0, $this_remove);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function IconView$_get_dragData_$ref_4jg2ny(p0) {
  return () => p0.jb9();
}
function IconView$_set_dragData_$ref_k36t82(p0) {
  return (_this__u8e3s4) => {
    p0.ib9(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var EditLineItem$render$slambdaClass;
function EditLineItem$render$slambda() {
  if (EditLineItem$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.thn_1 = this$0;
        this.uhn_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItem$render$slambdaClass = $;
  }
  return EditLineItem$render$slambdaClass;
}
function EditLineItem$render$slambda_0(this$0, $$this$button) {
  var i = new (EditLineItem$render$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var EditLineItem$render$slambdaClass_0;
function EditLineItem$render$slambda_1() {
  if (EditLineItem$render$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.whn_1 = $$this$button;
        this.xhn_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItem$render$slambdaClass_0 = $;
  }
  return EditLineItem$render$slambdaClass_0;
}
function EditLineItem$render$slambda_2($$this$button, this$0) {
  var i = new (EditLineItem$render$slambda_1())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItem$render$slambdaClass_1;
function EditLineItem$render$slambda_3() {
  if (EditLineItem$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.yhn_1 = this$0;
        this.zhn_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItem$render$slambdaClass_1 = $;
  }
  return EditLineItem$render$slambdaClass_1;
}
function EditLineItem$render$slambda_4(this$0, $$this$button) {
  var i = new (EditLineItem$render$slambda_3())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var EditLineItem$render$slambdaClass_2;
function EditLineItem$render$slambda_5() {
  if (EditLineItem$render$slambdaClass_2 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.aho_1 = $$this$button;
        this.bho_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItem$render$slambdaClass_2 = $;
  }
  return EditLineItem$render$slambdaClass_2;
}
function EditLineItem$render$slambda_6($$this$button, this$0) {
  var i = new (EditLineItem$render$slambda_5())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItem$render$slambdaClass_3;
function EditLineItem$render$slambda_7() {
  if (EditLineItem$render$slambdaClass_3 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.cho_1 = this$0;
        this.dho_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItem$render$slambdaClass_3 = $;
  }
  return EditLineItem$render$slambdaClass_3;
}
function EditLineItem$render$slambda_8(this$0, $$this$button) {
  var i = new (EditLineItem$render$slambda_7())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var EditLineItemClass;
function EditLineItem() {
  if (EditLineItemClass === VOID) {
    class $ {
      constructor(ogLine, projectId, reportTo, validateWhen, allowSave, onRemove, onSave) {
        reportTo = reportTo === VOID ? null : reportTo;
        allowSave = allowSave === VOID ? new (Constant())(_Constant___init__impl__v45mub(true)) : allowSave;
        var tmp;
        if (onSave === VOID) {
          tmp = EditLineItem$_init_$slambda_ohwzvp_0();
        } else {
          tmp = onSave;
        }
        onSave = tmp;
        this.xhm_1 = validateWhen;
        this.yhm_1 = allowSave;
        this.zhm_1 = onRemove;
        this.ahn_1 = onSave;
        var tmp_0 = this;
        tmp_0.bhn_1 = ogLine == null ? new (LineItem())(VOID, projectId) : ogLine;
        this.chn_1 = this.bhn_1.e6k_1;
        this.dhn_1 = Signal().hak(!(ogLine == null));
        this.ehn_1 = validated(Draft(this.bhn_1), reportTo);
        var tmp_1 = this;
        tmp_1.fhn_1 = lens(this.ehn_1, EditLineItem$scopeView$lambda);
        var tmp_2 = this;
        var tmp1_safe_receiver = ogLine == null ? null : ogLine.n6k_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toFileData(tmp1_safe_receiver);
        tmp_2.ghn_1 = Signal().hak(tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs);
        var tmp_3 = this;
        tmp_3.hhn_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!($this$remember.daj(this.ghn_1).p1() === $this$remember.daj(this.ehn_1).n6k_1.p1())) {
            tmp = true;
          } else {
            var tmp0 = this.ghn_1.f2();
            var tmp$ret$0;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_0;
              if (isInterface(tmp0, Collection())) {
                tmp_0 = tmp0.i1();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                var tmp_1;
                var tmp_2 = element.cgc_1;
                if (tmp_2 instanceof LocalFile()) {
                  tmp_1 = true;
                } else {
                  var tmp_3 = element.bgc_1.f2();
                  var tmp_4 = element.dgc_1;
                  var tmp0_safe_receiver = tmp_4 instanceof RemoteAttachment() ? tmp_4 : null;
                  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ugb_1;
                  tmp_1 = !(tmp_3 === (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i20()));
                }
                if (tmp_1) {
                  tmp$ret$0 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$0 = false;
            }
            tmp = tmp$ret$0;
          }
          return tmp;
        });
        this.ihn_1 = Signal().hak(false);
        this.jhn_1 = new (LineItemForm())(this.ehn_1, this.ghn_1, this.xhm_1);
        var tmp_4 = this;
        tmp_4.khn_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.dhn_1) && $this$remember.daj(this.jhn_1.jg8_1) && !$this$remember.daj(this.hhn_1));
        var tmp_5 = this;
        tmp_5.lhn_1 = Action('Save', VOID, EditLineItem$save$slambda_0(this));
        var tmp_6 = this;
        var tmp1_elvis_lhs = ogLine == null ? null : ogLine.j6k_1;
        tmp_6.mhn_1 = new (TargetHandler())(tmp1_elvis_lhs == null ? 'New Line' : tmp1_elvis_lhs);
        this.nhn_1 = this.jhn_1.sg8_1;
      }
      wg9() {
        return this.khn_1;
      }
      vhn(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_remove__l4h01w.bind(VOID, this, _this__u8e3s4), $completion);
      }
      eho(_this__u8e3s4, dragData) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_px(0));
        reactive(view, ($this$reactive) => {
          var tmp;
          var tmp_0;
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          if (this.xhm_1($this$reactive)) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp_0 = !$this$reactive.daj(get_issues(this.ehn_1)).i1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            this.ihn_1.oam(true);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        var $this$row = view_0;
        $this$row.bb9(get_px(0));
        dynamicTheme($this$row, ($this$dynamicTheme) => $this$dynamicTheme.daj(this.ihn_1) ? get_withoutPadding(SectionSemantic_getInstance()) : null);
        var tmp = $this$row.mba().vb0_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$2 = toDuration(50, DurationUnit_MILLISECONDS_getInstance());
        var tmp_0 = Duration__plus_impl_yu9v8f(tmp, tmp$ret$2);
        this.mhn_1.og4($this$row, tmp_0, () => {
          this.ihn_1.oam(true);
          return Unit_instance;
        });
        if (!(dragData == null)) {
          var tmp_1 = get_centered($this$row);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (IconView())($this$row.pc());
          var tmp0_elvis_lhs_1 = $this$row.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? $this$row : tmp0_elvis_lhs_1;
          $this$row.gbb(p_1, view_1);
          view_1.gbu('drag');
          view_1.sbt(get_dragHandle(Companion_getInstance_0()));
          var tmp_2 = KMutableProperty0();
          var tmp_3 = IconView$_get_dragData_$ref_4jg2ny(view_1);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('dragData', 0, tmp_2, tmp_3, IconView$_set_dragData_$ref_k36t82(view_1));
          reactiveScope(view_1, ($this$reactiveScope) => {
            var tmp$ret$3 = dragData.hcy(VOID, VOID, new (DragShadow())($this$row, Align_Start_getInstance(), Align_Start_getInstance()));
            this_0.set(tmp$ret$3);
            return Unit_instance;
          });
          $this$row.hbb(p_1, view_1);
          $this$row.lbb(tmp_1, view_1);
        }
        var tmp_4 = $this$row.kbb(sizeConstraints($this$row, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2.5)), get_expanding($this$row));
        $this$row.lbb(tmp_4, leftExpandButton($this$row, this.ihn_1, false, VOID, VOID, VOID, ($this$leftExpandButton) => {
          var tmp = get_expanding($this$leftExpandButton);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$leftExpandButton.pc());
          var tmp0_elvis_lhs = $this$leftExpandButton.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
          $this$leftExpandButton.gbb(p, view);
          view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_content_$ref_4pzcwl(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view));
          reactiveScope(view, ($this$reactiveScope) => {
            // Inline function 'kotlin.text.ifBlank' call
            var this_1 = $this$reactiveScope.daj(this.jhn_1.kg8_1);
            var tmp;
            if (isBlank(this_1)) {
              tmp = 'New Work Item';
            } else {
              tmp = this_1;
            }
            var tmp$ret$10 = tmp;
            this_0.set(tmp$ret$10);
            return Unit_instance;
          });
          $this$leftExpandButton.hbb(p, view);
          $this$leftExpandButton.lbb(tmp, view);
          var tmp_2 = $this$leftExpandButton.kbb(weight($this$leftExpandButton, 0.1), get_centered($this$leftExpandButton));
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())($this$leftExpandButton.pc());
          var tmp0_elvis_lhs_0 = $this$leftExpandButton.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? $this$leftExpandButton : tmp0_elvis_lhs_0;
          $this$leftExpandButton.gbb(p_0, view_0);
          view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
          view_0.dbs(Align_Center_getInstance());
          var tmp_3 = KMutableProperty0();
          var tmp_4 = TextView$_get_content_$ref_4pzcwl_0(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_0(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp$ret$17 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj(this.ehn_1).d6l_1);
            this_1.set(tmp$ret$17);
            return Unit_instance;
          });
          $this$leftExpandButton.hbb(p_0, view_0);
          $this$leftExpandButton.lbb(tmp_2, view_0);
          return Unit_instance;
        }));
        var tmp_5 = $this$row.kbb(get_centered($this$row), get_deleteButton($this$row));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Button())($this$row.pc());
        var tmp0_elvis_lhs_2 = $this$row.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
        $this$row.gbb(p_2, view_2);
        icon(view_2, resize(get_trash(Companion_getInstance_0()), get_rem(1.1)), 'Remove Work Item');
        onClick(view_2, VOID, VOID, EditLineItem$render$slambda_0(this, view_2));
        $this$row.hbb(p_2, view_2);
        $this$row.lbb(tmp_5, view_2);
        view.hbb(p_0, view_0);
        var tmp_6 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.ihn_1));
        // Inline function 'com.crowpay.views.components.indentIfWideCol' call
        var indent = Indent_CenteredSection_getInstance();
        var tmp_7;
        if (get_viewIsWide(view)) {
          // Inline function 'com.crowpay.views.components.indentedCol' call
          var tmp2 = indent.agr_1;
          // Inline function 'com.crowpay.views.components.indentedCol' call
          var afterSpace = indent.bgr_1;
          var tmp_8 = get_unpadded(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_3 = view.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.gbb(p_3, view_3);
          var tmp_9;
          var tmp_10 = null;
          if (!((tmp_10 == null ? null : new (Dimension())(tmp_10)) == null)) {
            tmp_9 = sizeConstraints(view_3, VOID, VOID, VOID, VOID, VOID, null);
          } else {
            tmp_9 = Companion_getInstance_1();
          }
          var tmp_11 = view_3.kbb(tmp_9, indented(view_3, tmp2, afterSpace));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.gbb(p_4, view_4);
          view_4.zbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Space())(view_4.pc(), 0.5);
          var tmp0_elvis_lhs_5 = view_4.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.gbb(p_5, view_5);
          view_4.hbb(p_5, view_5);
          render(this.jhn_1, view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (RowOrCol())(view_4.pc());
          var tmp0_elvis_lhs_6 = view_4.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
          view_4.gbb(p_6, view_6);
          view_6.zbm(false);
          view_6.bb9(get_AppDimensions().kg2_1);
          var tmp_12 = get_textButton(view_6);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (Button())(view_6.pc());
          var tmp0_elvis_lhs_7 = view_6.ebb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
          view_6.gbb(p_7, view_7);
          var tmp_13 = KMutableProperty0();
          var tmp_14 = Button$_get_enabled_$ref_61t7nx(view_7);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('enabled', 0, tmp_13, tmp_14, Button$_set_enabled_$ref_o8kynz(view_7));
          reactiveScope(view_7, ($this$reactiveScope) => {
            // Inline function 'kotlin.text.isNotEmpty' call
            var this_0 = $this$reactiveScope.daj(this.jhn_1.ng8_1);
            var tmp$ret$35 = charSequenceLength(this_0) > 0;
            this_1.set(tmp$ret$35);
            return Unit_instance;
          });
          specCenteredText(view_7, 'Save As Spec');
          onClick(view_7, VOID, VOID, EditLineItem$render$slambda_2(view_7, this));
          view_6.hbb(p_7, view_7);
          view_6.lbb(tmp_12, view_7);
          var tmp_15 = get_expanding(view_6);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (Space())(view_6.pc());
          var tmp0_elvis_lhs_8 = view_6.ebb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
          view_6.gbb(p_8, view_8);
          view_6.hbb(p_8, view_8);
          view_6.lbb(tmp_15, view_8);
          var tmp_16 = get_textButton(view_6);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (Button())(view_6.pc());
          var tmp0_elvis_lhs_9 = view_6.ebb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
          view_6.gbb(p_9, view_9);
          specCenteredText(view_9, 'Discard');
          onClick(view_9, VOID, VOID, EditLineItem$render$slambda_4(this, view_9));
          view_6.hbb(p_9, view_9);
          view_6.lbb(tmp_16, view_9);
          var tmp_17 = view_6.kbb(get_primaryButton(view_6), align(view_6, Align_End_getInstance(), Align_Center_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_10 = new (Button())(view_6.pc());
          var tmp0_elvis_lhs_10 = view_6.ebb_1;
          var p_10 = tmp0_elvis_lhs_10 == null ? view_6 : tmp0_elvis_lhs_10;
          view_6.gbb(p_10, view_10);
          var tmp_18 = KMutableProperty0();
          var tmp_19 = Button$_get_enabled_$ref_61t7nx_0(view_10);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_2 = getPropertyCallableRef('enabled', 0, tmp_18, tmp_19, Button$_set_enabled_$ref_o8kynz_0(view_10));
          reactiveScope(view_10, ($this$reactiveScope) => {
            var tmp$ret$46 = $this$reactiveScope.daj(get_issues(this.ehn_1)).i1();
            this_2.set(tmp$ret$46);
            return Unit_instance;
          });
          specCenteredText(view_10, 'Save');
          view_10.obg(this.lhn_1);
          view_6.hbb(p_10, view_10);
          view_6.lbb(tmp_17, view_10);
          view_4.hbb(p_6, view_6);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_11 = new (Space())(view_4.pc());
          var tmp0_elvis_lhs_11 = view_4.ebb_1;
          var p_11 = tmp0_elvis_lhs_11 == null ? view_4 : tmp0_elvis_lhs_11;
          view_4.gbb(p_11, view_11);
          view_4.hbb(p_11, view_11);
          view_3.hbb(p_4, view_4);
          view_3.lbb(tmp_11, view_4);
          view.hbb(p_3, view_3);
          tmp_7 = view.lbb(tmp_8, view_3);
        } else {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_12 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_12 = view.ebb_1;
          var p_12 = tmp0_elvis_lhs_12 == null ? view : tmp0_elvis_lhs_12;
          view.gbb(p_12, view_12);
          view_12.zbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_13 = new (Space())(view_12.pc(), 0.5);
          var tmp0_elvis_lhs_13 = view_12.ebb_1;
          var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
          view_12.gbb(p_13, view_13);
          view_12.hbb(p_13, view_13);
          render(this.jhn_1, view_12);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_14 = new (RowOrCol())(view_12.pc());
          var tmp0_elvis_lhs_14 = view_12.ebb_1;
          var p_14 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
          view_12.gbb(p_14, view_14);
          view_14.zbm(false);
          view_14.bb9(get_AppDimensions().kg2_1);
          var tmp_20 = get_textButton(view_14);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_15 = new (Button())(view_14.pc());
          var tmp0_elvis_lhs_15 = view_14.ebb_1;
          var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
          view_14.gbb(p_15, view_15);
          var tmp_21 = KMutableProperty0();
          var tmp_22 = Button$_get_enabled_$ref_61t7nx_1(view_15);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_3 = getPropertyCallableRef('enabled', 0, tmp_21, tmp_22, Button$_set_enabled_$ref_o8kynz_1(view_15));
          reactiveScope(view_15, ($this$reactiveScope) => {
            // Inline function 'kotlin.text.isNotEmpty' call
            var this_0 = $this$reactiveScope.daj(this.jhn_1.ng8_1);
            var tmp$ret$71 = charSequenceLength(this_0) > 0;
            this_3.set(tmp$ret$71);
            return Unit_instance;
          });
          specCenteredText(view_15, 'Save As Spec');
          onClick(view_15, VOID, VOID, EditLineItem$render$slambda_6(view_15, this));
          view_14.hbb(p_15, view_15);
          view_14.lbb(tmp_20, view_15);
          var tmp_23 = get_expanding(view_14);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_16 = new (Space())(view_14.pc());
          var tmp0_elvis_lhs_16 = view_14.ebb_1;
          var p_16 = tmp0_elvis_lhs_16 == null ? view_14 : tmp0_elvis_lhs_16;
          view_14.gbb(p_16, view_16);
          view_14.hbb(p_16, view_16);
          view_14.lbb(tmp_23, view_16);
          var tmp_24 = get_textButton(view_14);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_17 = new (Button())(view_14.pc());
          var tmp0_elvis_lhs_17 = view_14.ebb_1;
          var p_17 = tmp0_elvis_lhs_17 == null ? view_14 : tmp0_elvis_lhs_17;
          view_14.gbb(p_17, view_17);
          specCenteredText(view_17, 'Discard');
          onClick(view_17, VOID, VOID, EditLineItem$render$slambda_8(this, view_17));
          view_14.hbb(p_17, view_17);
          view_14.lbb(tmp_24, view_17);
          var tmp_25 = view_14.kbb(get_primaryButton(view_14), align(view_14, Align_End_getInstance(), Align_Center_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_18 = new (Button())(view_14.pc());
          var tmp0_elvis_lhs_18 = view_14.ebb_1;
          var p_18 = tmp0_elvis_lhs_18 == null ? view_14 : tmp0_elvis_lhs_18;
          view_14.gbb(p_18, view_18);
          var tmp_26 = KMutableProperty0();
          var tmp_27 = Button$_get_enabled_$ref_61t7nx_2(view_18);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_4 = getPropertyCallableRef('enabled', 0, tmp_26, tmp_27, Button$_set_enabled_$ref_o8kynz_2(view_18));
          reactiveScope(view_18, ($this$reactiveScope) => {
            var tmp$ret$82 = $this$reactiveScope.daj(get_issues(this.ehn_1)).i1();
            this_4.set(tmp$ret$82);
            return Unit_instance;
          });
          specCenteredText(view_18, 'Save');
          view_18.obg(this.lhn_1);
          view_14.hbb(p_18, view_18);
          view_14.lbb(tmp_25, view_18);
          view_12.hbb(p_14, view_14);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_19 = new (Space())(view_12.pc());
          var tmp0_elvis_lhs_19 = view_12.ebb_1;
          var p_19 = tmp0_elvis_lhs_19 == null ? view_12 : tmp0_elvis_lhs_19;
          view_12.gbb(p_19, view_19);
          view_12.hbb(p_19, view_19);
          view.hbb(p_12, view_12);
          tmp_7 = view_12;
        }
        var tmp$ret$98 = tmp_7;
        view.lbb(tmp_6, tmp$ret$98);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      wd6(_this__u8e3s4) {
        return this.eho(_this__u8e3s4, null);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'EditLineItem', VOID, VOID, [Page(), Form()], [1]);
    EditLineItemClass = $;
  }
  return EditLineItemClass;
}
//region block: exports
export {
  EditLineItem as EditLineItem2agpgpyrr30uy,
};
//endregion

//# sourceMappingURL=EditLineItem.mjs.map
